// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3xStr","question":"Question_question__ScZwE","description":"Question_description__mbgSH"};